<p-message severity="error" role="alert" data-testid="permissions-retry-banner">
  <div class="flex align-items-center gap-3">
    <span>{{ 'permissions.retryBanner.message' | translate }}</span>
    <button pButton type="button" class="p-button-sm" data-testid="permissions-retry" (click)="retry.emit()">
      {{ 'permissions.retryBanner.retry' | translate }}
    </button>
  </div>
</p-message>
